// `shortlist-extension-alerts.tpl.html:178` + `extension-alert-container.tpl.html:1` — the six
// elements between the content container and whatever renders the alert.
//
// ⚠️ THE REVIEW SCREEN NEEDS THIS TOO, AND IT WAS ONLY BUILT FOR THE EDIT SCREEN. Both states
// sit inside the same chain; only the two MODIFIER classes differ. Skipping it on the review
// side left `extension-alert-candidates` as a direct child of `.shortlist-content-container`,
// and the panel lost `.shortlist-item`'s `background-color: #f9feff` — a pale blue that shows
// through wherever the bars above the list do not paint, which is a full-width band no eye
// reads as missing and 645 pixels to a diff.
//
// `#content-scrollable-container` is the id `onExtensionCriteriaNavigationClicked` scrolls
// within, so it travels with the element rather than being set by whoever scrolls.
import { createElement, type ReactElement, type ReactNode } from 'react'

export interface AlertContainerHostProps {
  /**
   * `currentViewMode === FullMode`. It picks BOTH modifiers at once:
   * `.shortlist-item-full-view` on the scroll host and `general-side-padding-full` on the view
   * — the same boolean in two places, which is why it is one prop rather than two classes.
   */
  fullView?: boolean
  children?: ReactNode
}

export function AlertContainerHost({ fullView = false, children }: AlertContainerHostProps): ReactElement {
  return (
    <div
      className={`shortlist-item nicer-scroller mac-style${fullView ? ' shortlist-item-full-view' : ''}`}
      id="content-scrollable-container"
    >
      {createElement(
        'extension-alert-container',
        null,
        <div className="extension-alert-container">
          {/* `ng-if="state === VIEW && id !== NEW_ALERT_ID"` — the EDIT state renders
              `extension-alert-edit` in this slot instead, which is why `AlertEditFrame` has its
              own copy of the two elements above and stops here. */}
          <div
            className={`extension-alert-container-view ${
              fullView ? 'general-side-padding-full' : 'general-side-padding-slim'
            }`}
          >
            {/* `ng-if="extensionProduct === Candidates"` — the wrap is per product, and the
                product's own component element goes INSIDE it. That element is
                `CandidateListHost`'s, not this one's: it owns the three list wrappers that
                hang off it, and rendering it here as well would nest one inside the other. */}
            <div className="extension-alert-product-wrap">{children}</div>
          </div>
        </div>,
      )}
    </div>
  )
}
